<template>
  <div class="lead_resume">
    <v-card outlined>
      <v-card-title>
        {{ $capitalize($tc("model.leads_title_history")) }}
        <v-spacer />
        <v-btn
          icon
          @click="refreshLeadStatusHistory"
          :loading="refreshingHistory"
          ><v-icon>mdi-refresh</v-icon></v-btn
        >
      </v-card-title>
      <v-timeline dense>
        <v-timeline-item
          v-for="(status, index) in status_history"
          :key="status.pivot.id"
          :color="getStatusColor(index)"
          fill-dot
        >
          <v-row class="pt-1">
            <v-col>
              <strong>{{ status.name }}</strong>
              <div class="caption">
                {{
                  isLastItem(index)
                    ? ""
                    : $tc("model.leads_resume_duration_label") + " "
                }}<b>{{ getStatusDuration(index) }}</b>
                <br />
                {{ $capitalize($tc("model.leads_complement_in")) }}
                {{ formatDateTime(status.pivot.created_at) }}
                <br />
              </div>
            </v-col>
            <v-col cols="4"></v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { formatDateTime } from "@/tools/date";
import { getStatusHistory } from "@/services/lead";

export default {
  name: "lead-resume",
  data: () => ({
    refreshingHistory: false
  }),
  methods: {
    isLastItem(index) {
      return index == this.lead.status_history.length - 1;
    },
    getStatusDuration(index) {
      const actual_status = this.$moment(
        this.lead.status_history[index].pivot.created_at
      );

      const last_status = this.isLastItem(index);
      if (last_status) {
        return this.$moment
          .duration(actual_status.diff(this.$moment()))
          .humanize(last_status);
      } else {
        const next_status = this.$moment(
          this.lead.status_history[index + 1].pivot.created_at
        );

        return this.$moment
          .duration(next_status.diff(actual_status))
          .humanize(last_status);
      }
    },
    getStatusColor(index) {
      const last_status = index == this.lead.status_history.length - 1;
      const actual_status_color = this.lead.status_history[index].color;

      return last_status ? actual_status_color : "#ccc";
    },
    formatDateTime(date) {
      return formatDateTime(date);
    },
    updateStatusHistory(value) {
      this.$store.commit("setLead", {
        ...this.lead,
        status: value.status
      });

      this.$store.commit("setLeadStatusHistory", value.status_history);
    },
    async refreshLeadStatusHistory() {
      this.refreshingHistory = true;
      try {
        const response = await getStatusHistory(this.lead.id);

        this.updateStatusHistory(response);
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: "Não foi possível atualizar o histórico da lead",
          color: "red"
        });
      } finally {
        this.refreshingHistory = false;
      }
    }
  },
  computed: {
    ...mapState(["lead"]),
    status_history: function() {
      return this.$store.getters.getLeadStatusHistory;
    }
  }
};
</script>
